export enum StorageProviderType {
  localStorage = 'localStorage',
  sessionStorage = 'sessionStorage',
  inMemoryStorage = 'inMemoryStorage',
}
